import { render } from "./ProdutoDetalheView.vue?vue&type=template&id=0807cb0a"
import script from "./ProdutoDetalheView.vue?vue&type=script&lang=js"
export * from "./ProdutoDetalheView.vue?vue&type=script&lang=js"

import "./ProdutoDetalheView.vue?vue&type=style&index=0&id=0807cb0a&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__